import script from "./UserCommonSec.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCommonSec.vue?vue&type=script&setup=true&lang=js"

import "./UserCommonSec.vue?vue&type=style&index=0&id=1e7e3dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7e3dda"]])

export default __exports__